import _mapValues from "lodash/mapValues";
import _pickBy from "lodash/pickBy";
import _mapKeys from "lodash/mapKeys";
import { TableColumnInputType, TableColumns } from "src/requests/table/types";
import { createColumnInfoFromColumns } from "src/components/molecules/WhereItemEditor/components/tableDataGetterFactories/utils";
import { WhereItem, WhereItems } from "../../globalTypes";
import { getDefaultRelationTypeForColumnInfo } from "../../components/molecules/WhereItemEditor/utils";
import { createColumnDescriptor, createWhereItem } from "./creators";

const createDefaultItem = (columnName: string, columns: TableColumns) => {
  const columnInfo = createColumnInfoFromColumns(columns, columnName);
  const relationType = getDefaultRelationTypeForColumnInfo(columnInfo);

  const source = createColumnDescriptor({ columnIdentifier: columnName });

  return createWhereItem(relationType, { source });
};

const isColumnRepresentedInList = (list: WhereItem[], columnName: string) =>
  list.some((i) => i.source?.columnIdentifier === columnName);

const sortInputItems = (items: WhereItem[]) => {
  const basicItems: WhereItem[] = [];
  const overflowItems: WhereItem[] = [];

  items.forEach((inputItem) => {
    const basicItemForColumnAlreadyExists = isColumnRepresentedInList(
      basicItems,
      inputItem.source?.columnIdentifier ?? ""
    );

    if (basicItemForColumnAlreadyExists) {
      overflowItems.push(inputItem);
      return;
    }

    basicItems.push(inputItem);
  });

  return { basicItems, overflowItems };
};

const getVisibleColumns = (columns: TableColumns) =>
  _pickBy(
    columns,
    (column) => column.inputType !== TableColumnInputType.Hidden
  );

const getPlaceholderDict = (columns: TableColumns) =>
  _mapValues(
    getVisibleColumns(columns), // I <3 PRETTIER
    (_, colName) => createDefaultItem(colName, columns)
  );

const insertPlaceholders = (items: WhereItem[], columns: TableColumns) => {
  const allPlaceholders = getPlaceholderDict(columns);
  const itemsByCol = _mapKeys(items, (item) => item.source?.columnIdentifier);

  return Object.values({ ...allPlaceholders, ...itemsByCol });
};

const disableItems = (items: WhereItem[]): WhereItem[] =>
  items.map((i) => ({ ...i, disabled: true }));

// In the "basic" sections, items are disabled and there is
function adjustWhereItemsToDefaultSearchFormat(
  whereItems: WhereItems,
  columns: TableColumns
): WhereItems {
  const { basicItems, overflowItems } = sortInputItems(whereItems);

  const basicItemsWithPlaceholders = insertPlaceholders(basicItems, columns);
  const disabledBasicItemsWithPlaceholders = disableItems(
    basicItemsWithPlaceholders
  );

  return [...disabledBasicItemsWithPlaceholders, ...overflowItems];
}

export default adjustWhereItemsToDefaultSearchFormat;
